import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_33 } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const totalCommentsReceivedConfig = {
    name: 'kpi.tiktok.total_comments_received',
    tooltip: 'kpi.tiktok.tooltip_total_comments_received',
    id: 'comments',
    icon: {
        name: 'comments-on',
        style: colors.yellow
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    orientation: ORIENTATION_VERTICAL,
    size: SIZE_33,
    type: 'kpi',
    mergedData: true,
    element: KPIDefault,
    loader: DefaultLoader,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
